import React from 'react';
import RequestButton from '../RequestButton/RequestButton';

const RequestSystem: React.FC = () => {
  return <RequestButton fixed />;
};

export default RequestSystem; 